import { EMPTY_STRING } from 'constants/MeshbotConstant';

import { getActionOption } from './getActionOption';
import { getUserCodesItemIdByDevice } from './getUserCodesItemIdByDevice';

/**
 * Builds the trigger-update payload for an isUserLockOperation action selection, driven by the passed actionOptions.
 * An action that needs no PIN completes the block immediately with its fixed `userField` (e.g. -1); a PIN-requiring
 * action resolves the user_codes item id and waits for a PIN selection (empty user). Only capabilityDynamicFields is
 * returned — the method and selectedCapability are handled elsewhere. Pure (no config lookup).
 * @param {Array} actionOptions - the capability's action options (from config)
 * @param {Array} items - controller items
 * @param {string} deviceId - device id
 * @param {string} action - selected action (state token)
 * @returns {Object} onDataUpdate payload
 */
export const buildUserLockOperationActionData = (actionOptions, items, deviceId, action) => {
    const actionOption = getActionOption(actionOptions, action);

    if (!actionOption?.requiresPin) {
        return {
            capabilityDynamicFields: {
                stateFieldValue: action,
                userFieldValue: actionOption?.userField,
            },
        };
    }

    return {
        capabilityDynamicFields: {
            stateFieldValue: action,
            userCodesItemId: getUserCodesItemIdByDevice(items, deviceId),
            userFieldValue: EMPTY_STRING,
        },
    };
};
